module.exports = __webpack_public_path__ + "img/home-survey.a8e7f0cd.svg";